module.exports = __webpack_public_path__ + "static/media/oge3.png.f3315e1a.jpg";